import { useCopilotAction } from "@copilotkit/react-core";
import { getActiveCodes } from "api/commerce/access-code-service";
import { events, useRedeemCopilotAnalytics } from "../analytics";
import type { PurchasesProps } from "../components/Purchases";
import { COPILOT_ACTIONS } from "../constants/actions";
import { getCopilotAction } from "../helpers";
import { COPILOT_CHOICES } from "../instructions";
import type { ActionExecutionResult } from "../renderers";

export const useRcGetPurchases = () => {
	const { trackRedeemCopilotEvent } = useRedeemCopilotAnalytics();

	useCopilotAction({
		...getCopilotAction(COPILOT_ACTIONS.GET_PURCHASES),
		handler: async (): Promise<
			ActionExecutionResult<PurchasesProps | unknown>
		> => {
			try {
				const purchases = await getActiveCodes({});

				if (!purchases || purchases.length === 0) {
					const type = "error";
					const message = "No purchases found";

					trackRedeemCopilotEvent(events.findCodesFailed, {
						type,
						message,
					});

					return {
						type,
						message,
						instructions: COPILOT_CHOICES.FETCH_PURCHASES_ERROR,
					};
				}

				const type = "success";
				const message = "Purchases fetched successfully";

				trackRedeemCopilotEvent(events.findCodesSucceeded, {
					type,
					message,
				});

				return {
					type,
					message,
					result: { items: purchases } as PurchasesProps,
					instructions: COPILOT_CHOICES.FETCH_PURCHASES_SUCCESS,
				};
			} catch (e) {
				const type = "error";
				const message = e instanceof Error ? e.message : String(e);

				trackRedeemCopilotEvent(events.findCodesFailed, {
					type,
					message,
				});

				return {
					type,
					message,
					instructions: COPILOT_CHOICES.FETCH_PURCHASES_ERROR,
				};
			}
		},
	});
};
